import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postTakeApartOrder(params) {
  const { data } = await selfAxios.post(`/designapi/design/softwareOneKey/takeApartOrder`, params);
  return data;
}
export { postTakeApartOrder };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designapi/design/softwareOneKey/takeApartOrder/post.js